export const printersModule = {
    slug: 'printers',
    label: 'Impressoras',
    description: 'Impressoras expostas por agente.',
    icon: 'Printer',
};
//# sourceMappingURL=printers.js.map